export const environment = {
  production: false,
  apiUrl: 'https://gdams.green-delta.com/gdams_new_backend/api/',
  // apiUrl: 'http://192.168.69.140:8000/api/',
  pusherBeamsInstanceId: '9680b819-865c-45b9-86f1-92100c822f6b',
  appUrl: 'http://localhost:4200'
};